import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PROJECT} from '../../constants';

export default {
  id: 'CREATE_OPER',
  title: 'Wie legt man ein Projekt an?',
  description: '',
  categories: [CONTENT_CATEGORY_PROJECT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'So erstellen Sie ein Projekt:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Klicken Sie auf den Registerkarte "Projekte"'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_CREATE_OPER/DE_CREATE_OPER_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Auf "Neues Projekt erstellen" klicken'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_CREATE_OPER/DE_CREATE_OPER_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Wählen Sie die Art des zu erstellenden Projekts'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_CREATE_OPER/DE_CREATE_OPER_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Wählen Sie Ihre Rolle in diesem Projekt'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_CREATE_OPER/DE_CREATE_OPER_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Füllen Sie die Informationen über das Projekt aus'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_CREATE_OPER/DE_CREATE_OPER_5.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '6.',
    value: 'Klicken sie Weiter zur bestätigen'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_CREATE_OPER/DE_CREATE_OPER_6.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Nun müssen Sie nur noch die erforderlichen Dokumente auswählen und Ihren Kollegen den Zugriff auf das Projekt ermöglichen. (Siehe Kategorie "Meine Projekte").'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Sollten Sie kein Projekt anlegen können, wenden Sie sich bitte an Ihren Kundendienst.'
  }]
};
